import React, {useState} from 'react'
import { TooltipIcon } from './Components'
import LinkWrap from './LinkWrap'
import PicCont from './PicCont'
import { helper } from '../utilities/helper';
import Clickable from './Clickable';


let MiniProd = ({ prod, showPrice, units, noAdd }) => <LinkWrap disabled={noAdd} href={`/products/${helper.makeUrl(prod.name)}`} className='miniIncluded'>
<PicCont className='miniPic' picture={prod?.picture} alt={prod?.name} />
<span className='name'>{helper.shortText(prod?.name, 8)}</span>

{units > 0 && <span className='units' >{units} Units</span>}
</LinkWrap>

const IncludedProducts = ({products, product, noAdd}) => {
  let [open, setOpen]= useState(false)

  return <div className='includedProducts'>

  <div className="head"><TooltipIcon>These products will be included at no extra cost when renting {product.name}</TooltipIcon> Included with this Product:</div>
  <div className="prodsCol">
    {product?.included?.slice(0, open ?product?.included?.length: 4).map((comp, i) => <MiniProd noAdd={noAdd} prod={comp.product} units={comp.units} key={i} />)}
    {product?.included?.length >4 && !open && <Clickable onClick={() => setOpen(true)}>View {product?.included?.length-4} more included products.</Clickable>}
  </div>
</div>
}

export default IncludedProducts